import fileSaver from 'file-saver';
import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import t from './SupportingDocumentToDo.type';
import { ERROR_MESSAGE } from '../../../../../Components/helper';
import {
  getSupportingDocumentTodoList as getSupportingDocumentTodoListService,
  exportAllSupportingDocumentTodos,
  exportSelectedSupportingDocumentTodos,
  bulkDeleteSupportingDocumentTodos as bulkDeleteSupportingDocumentTodosService,
} from '../../../../../services/supporting-document-todo.service';
import TodoListType from '../../Samples/store/TodoList.type';

export const filterSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (error) {
    toasterMsg(error?.toString?.() || ERROR_MESSAGE, 'danger');
  }
};

export const getSupportingDocumentTodoList = (params) => async (dispatch) => {
  const requestId = params.requestId || Date.now().toString();
  try {
    if (!params?.isScrolled) {
      await dispatch({
        type: t.SET_FILTER_SORT_DATA,
        payload: { loading: true },
      });
    }

    const res = await getSupportingDocumentTodoListService(params);

    if (res?.code === 200) {
      const data = res?.data?.data || [];
      const totalCount = res?.data?.totalCount || 0;

      await dispatch({
        type: t.SET_SUPPORTING_DOCUMENT_TODO_LIST,
        payload: {
          data,
          totalCount,
          isScrolled: params?.isScrolled,
          searchText: params?.searchText,
          requestId,
        },
      });
      await dispatch({
        type: TodoListType.SET_TODO_LIST_COUNT,
        payload: {
          type: 'supporting-documents',
          totalCount,
          colour: '#FBB555',
        },
      });

      return true;
    }

    toasterMsg(res?.data?.errMsg || ERROR_MESSAGE, 'danger');
    await dispatch({
      type: t.SET_FILTER_SORT_DATA,
      payload: {
        loading: false,
      },
    });

    return false;
  } catch (error) {
    toasterMsg(error?.toString?.() || ERROR_MESSAGE, 'danger');
    await dispatch({
      type: t.SET_FILTER_SORT_DATA,
      payload: {
        loading: false,
      },
    });
    return false;
  }
};

export const downloadAllSupportingDocumentTodos =
  (params = {}, t) =>
  async () => {
    try {
      const filterValues = params?.filterValues ?? {};
      const response = await exportAllSupportingDocumentTodos({
        searchText: filterValues?.searchText,
        expiry: filterValues?.expiry,
      });
      const payload = response?.data ?? response;
      const downloadUrl = payload?.downloadUrl;
      if (downloadUrl) {
        const preparingMessage = t
          ? t('SUPPORTING_DOCUMENT.DOWNLOAD_ALL_WILL_DOWNLOAD')
          : 'Export complete. The zip will be downloaded automatically in a moment.';
        toasterMsg(preparingMessage, 'success');
        const filename = payload?.filename ?? `SupportingDocuments_All_${new Date().getTime()}.zip`;
        try {
          const blobResponse = await fetch(downloadUrl, { mode: 'cors' });
          if (!blobResponse.ok) throw new Error(blobResponse.statusText);
          const blob = await blobResponse.blob();
          fileSaver.saveAs(blob, filename);
        } catch (fetchErr) {
          const downloadFailedMessage = t
            ? t('SUPPORTING_DOCUMENT.DOWNLOAD_COULD_NOT_START')
            : 'The download could not start automatically, please try again later.';
          toasterMsg(downloadFailedMessage, 'danger');
        }
      } else if (payload?.message) {
        toasterMsg(payload.message, 'warning');
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ??
        error?.response?.data?.error ??
        error?.response?.data?.errMsg ??
        error?.message ??
        (t ? t('SUPPORTING_DOCUMENT.DOWNLOAD_ALL_ERROR') : 'Failed to download all supporting documents');
      toasterMsg(errorMessage, 'danger');
    }
  };

export const downloadSelectedSupportingDocumentTodos = (selectedIds, t) => async () => {
  try {
    if (!selectedIds || !Array.isArray(selectedIds) || selectedIds.length === 0) {
      const warningMessage = t ? t('SUPPORTING_DOCUMENT.SELECT_RECORDS_TO_DOWNLOAD') : 'Please select documents to download';
      toasterMsg(warningMessage, 'warning');
      return;
    }
    const response = await exportSelectedSupportingDocumentTodos(selectedIds);
    const payload = response?.data ?? response;
    const downloadUrl = payload?.downloadUrl;
    if (downloadUrl) {
      const preparingMessage = t
        ? t('SUPPORTING_DOCUMENT.DOWNLOAD_ALL_WILL_DOWNLOAD')
        : 'Export complete. The zip will be downloaded automatically in a moment.';
      toasterMsg(preparingMessage, 'success');
      const filename = payload?.filename ?? `SupportingDocuments_Selected_${new Date().getTime()}.zip`;
      try {
        const blobResponse = await fetch(downloadUrl, { mode: 'cors' });
        if (!blobResponse.ok) throw new Error(blobResponse.statusText);
        const blob = await blobResponse.blob();
        fileSaver.saveAs(blob, filename);
      } catch (fetchErr) {
        const downloadFailedMessage = t
          ? t('SUPPORTING_DOCUMENT.DOWNLOAD_COULD_NOT_START')
          : 'The download could not start automatically, please try again later.';
        toasterMsg(downloadFailedMessage, 'danger');
      }
    } else if (payload?.message) {
      toasterMsg(payload.message, 'warning');
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ??
      error?.response?.data?.error ??
      error?.response?.data?.errMsg ??
      error?.message ??
      (t ? t('SUPPORTING_DOCUMENT.DOWNLOAD_SELECTED_ERROR') : 'Failed to download selected documents');
    toasterMsg(errorMessage, 'danger');
  }
};

export const bulkDeleteSupportingDocumentTodos = (docIds, transactionMsg) => async (dispatch, getState) => {
  try {
    if (!docIds || !Array.isArray(docIds) || docIds.length === 0) {
      const warningMessage = transactionMsg ? transactionMsg('SUPPORTING_DOCUMENT.SELECT_RECORDS_TO_DELETE') : 'Please select documents to delete';
      toasterMsg(warningMessage, 'warning');
    } else {
      const res = await bulkDeleteSupportingDocumentTodosService(docIds);

      if (res?.code === 200) {
        const msg = transactionMsg ? transactionMsg(`${res.message}`) : 'Documents deleted successfully';
        toasterMsg(msg, 'success');

        await dispatch({
          type: t.BULK_DELETE_SUPPORTING_DOCUMENTS,
          payload: { deletedIds: docIds },
        });
        const newCount = Math.max(
          0,
          docIds.length > 0 ? (getState()?.SupportingDocumentTodoListData?.supportingDocumentTodoListTotalCount || 0) - docIds.length : 0,
        );

        await dispatch({
          type: TodoListType.SET_TODO_LIST_COUNT,
          payload: {
            type: 'supporting-documents',
            totalCount: newCount,
            colour: '#FBB555',
          },
        });
      } else {
        toasterMsg(res?.data?.errMsg || ERROR_MESSAGE, 'danger');
      }
    }
  } catch (error) {
    toasterMsg(error?.toString?.() || ERROR_MESSAGE, 'danger');
  }
};
